module.exports = __webpack_public_path__ + "static/img/steel-ingot_256.6e692db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/steel-ingot_256.png
// module id = yyYZ
// module chunks = 0